/* MOONZART · Interacciones ligeras para secciones mz-pdp-* (sin dependencias) */
(function () {
  if (window.__mzsInit) return;
  window.__mzsInit = true;

  /* Aparición suave al hacer scroll */
  function reveal(root) {
    var els = (root || document).querySelectorAll('.mzs [data-mzs-rv]:not(.is-in)');
    if (!('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Vídeo con portada: reproduce al pulsar */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-mzs-play]');
    if (!b) return;
    var box = b.closest('.mzs-vid__box');
    var v = box && box.querySelector('video');
    if (!v) return;
    box.classList.add('is-playing'); v.muted = false; v.removeAttribute('muted'); v.volume = 1;
    v.setAttribute('controls', '');
    v.play && v.play();
  });

  /* Vídeos: al darles play, se reproducen con sonido */ document.addEventListener('play', function (e) { var v = e.target; if (!v || v.tagName !== 'VIDEO' || !v.closest || !v.closest('.mzs-vid__box')) return; if (v.muted && navigator.userActivation && navigator.userActivation.isActive) { v.muted = false; v.removeAttribute('muted'); v.volume = 1; } }, true); /* CTA: lleva a la zona de compra sin crear otro formulario */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-mzs-to-buy]');
    if (!a) return;
    var t = document.querySelector('.product-information product-form-component, .product-information form[action*="/cart/add"]');
    if (!t) return;
    ev.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* Guía de tallas: abre la calculadora existente del tema */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-mzs-size-calc]');
    if (!a) return;
    var trg = document.querySelector('[data-cs-open-size-modal], .cs-find-size-link');
    if (trg) { ev.preventDefault(); trg.click(); }
  });

  /* Completa tu look: añade al carrito solo las prendas marcadas por la clienta */
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    try { if (window.upcartRefreshCart) window.upcartRefreshCart(); } catch (e) {}
    try { if (window.upcartOpenCart) { window.upcartOpenCart(); return true; } } catch (e) {}
    return false;
  }
  document.addEventListener('change', function (ev) {
    var c = ev.target.closest('[data-mzs-cl-on]');
    if (c) c.closest('.mzs-cl__card').classList.toggle('is-off', !c.checked);
    var s = ev.target.closest('[data-mzs-cl-var]');
    if (s) {
      var card = s.closest('.mzs-cl__card');
      var opt = s.options[s.selectedIndex];
      var pr = card.querySelector('[data-mzs-cl-price]');
      if (pr && opt) pr.textContent = opt.getAttribute('data-price');
    }
  });
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-mzs-cl-add]');
    if (!btn) return;
    var sec = btn.closest('.mzs-cl');
    var msg = sec.querySelector('.mzs-cl__msg');
    var items = [];
    sec.querySelectorAll('.mzs-cl__card').forEach(function (card) {
      var on = card.querySelector('[data-mzs-cl-on]');
      var sel = card.querySelector('[data-mzs-cl-var]');
      if (on && on.checked && sel && sel.value) items.push({ id: parseInt(sel.value, 10), quantity: 1 });
    });
    if (!items.length) { msg.textContent = msg.getAttribute('data-empty'); return; }
    btn.disabled = true;
    msg.textContent = '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.disabled = false;
        if (!res.ok) { msg.textContent = (res.j && (res.j.description || res.j.message)) || msg.getAttribute('data-error'); return; }
        msg.textContent = msg.getAttribute('data-ok');
        if (!refreshCart()) setTimeout(function () { window.location.href = root + 'cart'; }, 600);
      })
      .catch(function () { btn.disabled = false; msg.textContent = msg.getAttribute('data-error'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { reveal(); });
  else reveal();
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
